export default {
    '1': 'Producto equivocado',
    '2': 'Pedido duplicado',
    '3': 'No se puede recibir',
    '4': 'Otras razones',
    '-连接已建立-': '-Conexión establecida-',
    ',才可提币': ', para poder retirar',
    '[code]值错误': 'Valor de [code] incorrecto',
    '[symbol]参数为空': 'El parámetro [symbol] está vacío',
    homeDownloadtips41: 'App del comerciante',
    '不能为空': 'No puede estar vacío',
    '不在交易时段': 'Fuera del horario de negociación',
    '不在可提现时间内': 'Fuera del horario de retiro',
    '参数错误': 'Error de parámetro',
    '参数异常，消息获取失败': 'Parámetro anómalo, no se pudo obtener el mensaje',
    '操作成功': 'Operación exitosa',
    '操作类型不能小于0': 'El tipo de operación no puede ser menor que 0',
    '操作类型不是整数': 'El tipo de operación no es un número entero',
    '操作类型为空': 'El tipo de operación está vacío',
    '产品不存在': 'El producto no existe',
    '产品剩余数量不足': 'Cantidad restante del producto insuficiente',
    '承兑商不存在': 'El comerciante no existe',
    '程序错误': 'Error del programa',
    '持有币种不足': 'Saldo de moneda insuficiente',
    '充值价值不得大于最大限额': 'El valor de recarga no puede superar el límite máximo',
    '充值价值不得小于最小限额': 'El valor de recarga no puede ser menor que el límite mínimo',
    '充值链错误': 'Error en la cadena de recarga',
    '充值数量不能小于等于0': 'La cantidad de recarga no puede ser menor o igual a 0',
    '存在不同杠杆的持仓单': 'Existen posiciones con diferente apalancamiento',
    '存在重复的角色名称': 'Existe un nombre de rol duplicado',
    '大于最大采购数量': 'Mayor que la cantidad máxima de compra',
    '代理层级错误': 'Error de nivel de agente',
    '待付款的订单无法放行': 'No se puede liberar un pedido pendiente de pago',
    '当前地址格式错误': 'Formato de dirección actual incorrecto',
    '当前订单不为待付款状态，无法取消': 'El pedido no está en estado pendiente de pago, no se puede cancelar',
    '当前还需交易': 'Aún se requiere operar',
    '当日才可申购': 'La suscripción solo es posible el mismo día',
    '当日可提现次数不足': 'Número de retiros de hoy insuficiente',
    '登陆密码不符合设定': 'La contraseña de acceso no cumple los requisitos',
    '登陆密码长度不符合设定': 'La longitud de la contraseña de acceso no cumple los requisitos',
    '登录过期，请重新登录': 'Sesión expirada, vuelve a iniciar sesión',
    '登录密码必须6-12位': 'La contraseña de acceso debe tener 6-12 caracteres',
    '登录密码不能为空': 'La contraseña de acceso no puede estar vacía',
    '登录失败': 'Error al iniciar sesión',
    '电话号码已绑定': 'El número de teléfono ya está vinculado',
    '电话号码已绑定其他用户': 'El número de teléfono ya está vinculado a otro usuario',
    '订单不存在': 'El pedido no existe',
    '订单已取消': 'Pedido cancelado',
    '订单已取消，无法放行': 'Pedido cancelado, no se puede liberar',
    '订单已完成，无法放行': 'Pedido completado, no se puede liberar',
    '发现新版本，请升级到最新版本': 'Nueva versión disponible, actualiza a la última versión',
    '服务器错误': 'Error del servidor',
    '服务器错误(500)': 'Error del servidor (500)',
    '该产品未上架': 'Este producto no está publicado',
    '该产品已上市，无法购买': 'Este producto ya está publicado, no se puede comprar',
    '该订单已取消': 'Este pedido ha sido cancelado',
    '该广告剩余数量不足': 'Cantidad restante de este anuncio insuficiente',
    '该基金尚未开放购买': 'Este fondo aún no está disponible para la compra',
    '该基金尚已封闭': 'Este fondo ya está cerrado',
    '该邮箱已被订阅': 'Este correo ya está suscrito',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Error de formato: el monto de recarga no puede ser menor que 1 (con dos decimales)',
    '跟单倍数输入错误': 'Entrada incorrecta del multiplicador de copy trading',
    '跟单参数输入错误': 'Entrada incorrecta de los parámetros de copy trading',
    '更新提醒': 'Aviso de actualización',
    '工作地址不能为空': 'La dirección laboral no puede estar vacía',
    '购买矿机时间不得低于托管订单剩余时间': 'La duración de compra de la máquina de minería no puede ser inferior al tiempo restante del pedido de alojamiento',
    '广告不存在': 'El anuncio no existe',
    '广告已下架': 'El anuncio fue retirado',
    '基金剩余购买金额不足': 'Monto de compra restante del fondo insuficiente',
    '家庭地址不能为空': 'La dirección particular no puede estar vacía',
    '交易员不存在': 'El trader no existe',
    '交易员不能跟随自己': 'El trader no puede seguirse a sí mismo',
    '交易员跟随人数已满': 'El número de seguidores del trader está completo',
    '交易员未开启带单': 'El trader no ha activado el copy trading',
    '交易员无法跟随另一个交易员': 'Un trader no puede seguir a otro trader',
    '角色被用户关联，不可删除': 'El rol está vinculado a usuarios, no se puede eliminar',
    '角色不存在': 'El rol no existe',
    '金额不在购买区间': 'El monto no está en el rango de compra',
    '金额错误': 'Error de monto',
    '旧密码不能为空': 'La contraseña anterior no puede estar vacía',
    '旧密码不正确': 'La contraseña anterior es incorrecta',
    '可平仓合约张数不足': 'Número de contratos cerrables insuficiente',
    '矿机不存在': 'La máquina de minería no existe',
    '矿机未解锁，无法购买': 'La máquina de minería no está desbloqueada, no se puede comprar',
    '历史基金无法购买': 'Los fondos históricos no se pueden comprar',
    '连续输入错误三次，请3分钟后再试': 'Tres entradas incorrectas seguidas, inténtalo de nuevo en 3 minutos',
    '领取成功': 'Recibido con éxito',
    '买入金额需要在区间内': 'El monto de compra debe estar dentro del rango',
    '卖方无法取消该订单': 'El vendedor no puede cancelar este pedido',
    '没有找到用户': 'No se encontró el usuario',
    verificationCode: 'Código de verificación',
    pleaseEnterVerificationCode: 'Introduce el código de verificación',
    pleaseEnterUsername: 'Introduce el nombre de usuario',
    username: 'Nombre de usuario',
    getVerificationCode: 'Obtener código',
    tryAgainLater: 'segundos para reintentar',
    '密码必须6-12位': 'La contraseña debe tener 6-12 caracteres',
    '密码不能为空': 'La contraseña no puede estar vacía',
    '密码不正确': 'La contraseña es incorrecta',
    '您当前可分配额度不足': 'Tu límite asignable actual es insuficiente',
    '您没有符合条件的收款方式': 'No tienes un método de cobro válido',
    '您已存在订单': 'Ya tienes un pedido',
    '您已购买过体验矿机,不得重复购买': 'Ya has comprado una máquina de minería de prueba, no puedes comprar de nuevo',
    '亲属地址不能为空': 'La dirección del familiar no puede estar vacía',
    '亲属电话不能为空': 'El teléfono del familiar no puede estar vacío',
    '亲属关系不能为空': 'El parentesco no puede estar vacío',
    '亲属姓名不能为空': 'El nombre del familiar no puede estar vacío',
    '请检查网络连接': 'Comprueba la conexión de red',
    '请上传图片': 'Sube una imagen',
    '请稍后再试': 'Inténtalo de nuevo más tarde',
    '请稍后重试': 'Inténtalo de nuevo más tarde',
    '请输入充值币种': 'Introduce la moneda de recarga',
    '请输入内容': 'Introduce el contenido',
    '请输入搜索关键字': 'Introduce la palabra clave de búsqueda',
    '请输入正确的货币数量': 'Introduce una cantidad de moneda válida',
    '请输入正确的金额': 'Introduce un monto válido',
    '请输入正确的数量': 'Introduce una cantidad válida',
    '请输入正确的质押金额': 'Introduce un monto de staking válido',
    '请输入正确的质押天数': 'Introduce un número de días de staking válido',
    '请填写正确的电话号码': 'Introduce un número de teléfono válido',
    '请填写正确的验证码': 'Introduce un código de verificación válido',
    '请填写正确的邮箱地址': 'Introduce una dirección de correo válida',
    '请先绑定谷歌验证器': 'Primero vincula Google Authenticator',
    '请先添加收款方式': 'Primero añade un método de cobro',
    '请先通过高级认证': 'Primero completa la verificación avanzada',
    '请选择买卖方式': 'Selecciona el método de compra/venta',
    '请选择正确的币种': 'Selecciona la moneda correcta',
    '请重新登录': 'Vuelve a iniciar sesión',
    '渠道未开通': 'Canal no activado',
    '取消': 'Cancelar',
    '确认': 'Confirmar',
    '申购数量错误': 'Cantidad de suscripción incorrecta',
    '申请成功': 'Solicitud exitosa',
    '身份证已实名过!': '¡El documento de identidad ya está verificado!',
    '审核已通过': 'Revisión aprobada',
    '审核中': 'En revisión',
    '实名认证未通过，无法进行高级认证': 'La verificación de identidad no se aprobó, no se puede realizar la verificación avanzada',
    '收款方输入错误': 'Entrada incorrecta del beneficiario',
    '授权状态未成功': 'Estado de autorización no exitoso',
    '赎回状态异常': 'Estado de reembolso anómalo',
    '所选汇率不存在': 'El tipo de cambio seleccionado no existe',
    '提币数量不能小于等于0': 'La cantidad de retiro no puede ser menor o igual a 0',
    '提交失败，当前有未处理订单': 'Error al enviar, hay pedidos sin procesar',
    '提示': 'Aviso',
    '提现不得大于限额': 'El retiro no puede superar el límite',
    '提现不得小于限额': 'El retiro no puede ser menor que el límite',
    '图片不得大于10M': 'La imagen no puede superar los 10 MB',
    '图片不得大于2M': 'La imagen no puede superar los 2 MB',
    '图片大小不能超过2M！': '¡El tamaño de la imagen no puede superar los 2 MB!',
    '图片上传失败': 'Error al subir la imagen',
    '推荐码不正确': 'El código de referido es incorrecto',
    '推荐人无权限推荐': 'El referente no tiene permiso para referir',
    '委托数量(张)必填': 'La cantidad de la orden (contratos) es obligatoria',
    '委托数量(张)不能小于等于0': 'La cantidad de la orden (contratos) no puede ser menor o igual a 0',
    '未绑定谷歌验证器': 'Google Authenticator no vinculado',
    '未绑定手机号': 'Sin número de teléfono vinculado',
    '未绑定邮箱': 'Sin correo vinculado',
    '未发现授权记录': 'No se encontró registro de autorización',
    '未实名认证，是否认证？': 'No verificado. ¿Verificar ahora?',
    '未授权访问': 'Acceso no autorizado',
    '未找到符合条件的匹配订单': 'No se encontró un pedido coincidente',
    '未找到匹配的收益记录': 'No se encontró un registro de ingresos coincidente',
    myComment: 'Mis reseñas',
    myPoint: 'Mis puntos',
    accountInfo: 'Información de la cuenta',
    myBalance: 'Mi saldo',
    myCoupon: 'Mis cupones',
    unused: 'Sin usar',
    used: 'Usado',
    expired: 'Caducado',
    expires: 'Válido hasta',
    minSpend: 'Mínimo',
    availableBalance: 'Saldo disponible',
    personalDeposit: 'Saldo',
    useDepositBalance: 'Usar saldo para descuento',
    depositDeduct: 'Descuento de saldo',
    useMaxDeposit: 'Descuento total',
    balanceHistory: 'Historial de saldo',
    recordCount: 'Total {count} registros',
    depositType: 'Tipo de transacción',
    balanceAfter: 'Saldo restante',
    depositTypeRecharge: 'Recarga de saldo',
    depositTypeAdjustment: 'Ajuste de saldo',
    depositTypeOrderPayment: 'Pago de pedido',
    depositTypeOrderRefunds: 'Reembolso de pedido',
    depositTypeDistributionCommission: 'Comisión de distribución',
    depositTypeDistributionWithdrawal: 'Retiro de distribución',
    depositTypeOther: 'Otros',
    income: 'Ingreso',
    expense: 'Gasto',
    description: 'Descripción',
    myFootprint: 'Mi historial',
    '无权限': 'Sin permiso',
    '无效的UID': 'UID no válido',
    '系统参数错误': 'Error de parámetro del sistema',
    '系统存在相同[系统登录名]！': '¡El sistema ya tiene el mismo [nombre de acceso]!',
    '系统错误，请稍后重试': 'Error del sistema, inténtalo de nuevo más tarde',
    '下单不能小于最小金额限制': 'El pedido no puede ser menor que el monto mínimo',
    '校验IP不合法': 'IP de verificación no válida',
    '新密码不能为空': 'La nueva contraseña no puede estar vacía',
    '新密码不一致': 'Las nuevas contraseñas no coinciden',
    '新密码确认不能为空': 'La confirmación de la nueva contraseña no puede estar vacía',
    '行情获取异常，稍后再试': 'No se pudieron obtener los datos del mercado, inténtalo más tarde',
    '验证类型不能为空': 'El tipo de verificación no puede estar vacío',
    '验证码不能为空': 'El código de verificación no puede estar vacío',
    '验证码不正确': 'El código de verificación es incorrecto',
    '验证码错误': 'Código de verificación erróneo',
    '页码不能小于等于0': 'El número de página no puede ser menor o igual a 0',
    '页码不是整数': 'El número de página no es un entero',
    '已领取': 'Ya recibido',
    '用户不存在': 'El usuario no existe',
    '用户名必须由数字和英文字母组成': 'El nombre de usuario debe estar compuesto por números y letras latinas',
    '用户名不存在': 'El nombre de usuario no existe',
    '用户名不符合设定': 'El nombre de usuario no cumple los requisitos',
    '用户名不能为空': 'El nombre de usuario no puede estar vacío',
    '用户名参数为空': 'El parámetro de nombre de usuario está vacío',
    '用户名重复': 'Nombre de usuario duplicado',
    '用户剩余数量不足': 'Cantidad restante de usuarios insuficiente',
    '用户已跟随交易员': 'El usuario ya sigue al trader',
    '邮箱已绑定': 'Correo ya vinculado',
    '邮箱已绑定其他用户': 'El correo ya está vinculado a otro usuario',
    '余额不足': 'Saldo insuficiente',
    shop_order_insufficientBalance: 'Saldo de la cuenta insuficiente',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Cuenta anómala, se requiere verificación C3. Contacta con el servicio de atención en línea.',
    '找不到用户': 'Usuario no encontrado',
    flashSale: 'Venta flash',
    groupBuy: 'Compra en grupo',
    groupBuying: 'Compra grupal',
    couponCenter: 'Centro de cupones',
    pointMall: 'Tienda de puntos',
    liveList: 'En directo',
    endsIn: 'Termina en',
    soldOut: 'Vendido',
    people: 'personas',
    joined: 'Se han unido',
    startGroup: 'Iniciar grupo',
    getCoupon: 'Obtener',
    '直线关系，不能修改推荐': 'Relación directa, no se puede modificar el referido',
    '重复提交': 'Envío duplicado',
    '转账币种不能为空': 'La moneda de transferencia no puede estar vacía',
    '转账数量不能小于等于0': 'La cantidad de transferencia no puede ser menor o igual a 0',
    '状态不能小于0': 'El estado no puede ser menor que 0',
    '状态不是整数': 'El estado no es un entero',
    '资金密码必须6-12位': 'La contraseña de fondos debe tener 6-12 caracteres',
    '资金密码不符合设定': 'La contraseña de fondos no cumple los requisitos',
    '资金密码不能为空': 'La contraseña de fondos no puede estar vacía',
    '资金密码错误': 'Contraseña de fondos incorrecta',
    '资金密码长度不符合设定': 'La longitud de la contraseña de fondos no cumple los requisitos',
    'UID不能为空': 'El UID no puede estar vacío',
    required: 'Este campo es obligatorio',
    nickname: 'Apodo',
    enterNickname: 'Introduce un apodo',
    gender: 'Género',
    male: 'Hombre',
    female: 'Mujer',
    secret: 'Confidencial',
    birthday: 'Cumpleaños',
    selectDate: 'Seleccionar fecha',
  cancelOrderMap: {
    0: "no lo quiero",
    1: "extravió el producto",
    2: "Duplicar la orden",
    3: "Recepción fallida",
    4: "Otras razones",
  },
  "获取验证码": "Obtener código de verificación",
  "验证码": "Código de verificación",
  "请输入验证码": "Por favor ingrese el código de verificación",
  "发送":"Enviar",
  "已发送，请注意查收": "Enviado, por favor revise la recepción",
  "电商批发商场": "Mercado mayorista de comercio electrónico",
  "用户未发表评论": "El usuario no ha comentado",
  "请输入完整的支付密码!" : "Por favor ingrese la contraseña completa",
  "订单": "Orden",
  "下单成功，等待付款": "Pedido realizado correctamente, esperando pago",
  "下单成功，付款成功": "Pedido realizado con éxito, pago realizado correctamente",
  "已发货，正在运输中": "Enviado, en transporte",
  "订单已取消，原因:手动发起取消订单": "El pedido ha sido cancelado. Motivo: Cancelar el pedido manualmente.",
  "订单已取消，原因:超时自动取消订单": "El pedido ha sido cancelado. Motivo: el pedido se cancelará automáticamente cuando se agote el tiempo de espera.",
  "商家已确认，已进入备货状态": "El comerciante ha sido confirmado y ha ingresado al estado de stock.",
  "系统发货成功": "Entrega del sistema exitosa",
  "订单已签收": "Orden recibida",
  "发起退款申请": "Iniciar una solicitud de reembolso",
  "退款成功": "Reembolso exitoso",
  "退款失败": "Reembolso fallido",
  "订单退款成功": "Reembolso del pedido realizado correctamente",
  "订单退款失败": "Reembolso del pedido fallido",
  "系统默认好评": "El sistema muestra por defecto revisiones favorables.",
  "请输入关键字搜索": "Por favor ingrese la palabra clave para buscar",
  "猜你喜欢": "Supongo que te gusta",
  "订单已完成": "El pedido está completo",
  "热销推荐": "Recomendación de venta caliente",
  "头像选择": "Выбор аватара",
  "修改头像": "Modifica tu avatar",
  subOrder: "Orden de envio",
  "mailboxCheck": "Por favor complete la dirección de correo electrónico correcta",
  "switchLang": "Cambie a otro idioma para ver",
  "myCart": "Mi carrito de compras",
  "notQua": "No se cumplen las condiciones de calificación.",
  "noSmaller": "El monto aplicado no puede ser inferior a",
  "nomax": "La cantidad máxima de aplicación no puede exceder",
  "evaluationUploading": "Todavía tienes fotos subiendo. Por favor, inténtelo de nuevo más tarde",
  "evaluateInput": "Reseña con fotos",
  "moneyOrderStatus": "Estado del pedido",
  "coinBlock": "Acuerdo de divisas",
  "dealing": "En proceso",
  "dealSuccess": "Exitoso",
  "dealFail": "Fallar",
  "payCertificate": "Certificado de pago",
  "handleFee": "Cargo por servicio",
  "highOpinion": "Buenas críticas",
  "mediumOpinion": "Reseña media",
  "lowOpinion": "Malas críticas",
  "hasImage": "Con imagenes",
  "rechargeMethod": "Modo de recarga",
  "scanAndDown": "Escanear código QR Descargar aplicación",
  "receivedAddress": "dirección de recepción",
  "ActualLedger": "Recibo real",
  "view": "Vista",
  "withdrawNum": "Cantidad de retiro de efectivo",
  "rechargeNum": "Cantidad de recarga",
  "date": "Fecha",
  "walletHistory": "Historial de la billetera",
  "accountBalance": "Saldo de la cuenta",
  "accountReview": "Descripción de cuenta",
  "rated": "Revisado",
  "receiver": "Receptor",
  "orderStatus": "Estado",
  "orderTime": "Tiempo",
  "tax": "Impuestos",
  "discount": "Descuento",
  "productInfo": "Información del Producto",
  "paramError": "error de parametro",
  "orderInfo": "Información del pedido",
  "rebuy": "un pedido mas",
  "pleaseCorrectAddress": "Ingrese la dirección de retiro de efectivo correcta",
  "pleaseInputCorrectNumber": "Por favor, introduzca un número mayor que 0",
  "vcodePass": "¡Verificación superada!",
  "vcodeFail": "Autenticación fallida. Por favor intente de nuevo",
  "uploading": "Subiendo...",
  "uploadSuccess": "Subido correctamente",
  "uploadError": "Subida fallida. Inténtalo de nuevo",
  "registerSuccess": "Registro exitoso",
  "pleaseSetMobileNumber": "Por favor, establezca el número de teléfono",
  "unSelectedProduct": "No has seleccionado un producto",
  "loginSuccess": "Inicio de sesión exitoso",
  "pleaseSetAreaCode": "Ingrese el nombre del país y el código de área para buscar",
  "login": "Acceso",
  "register": "Registro",
  "logout": "Salida",
  "noData": "Datos no encontrados",
  "search": "Buscar",
  "historySearch": "Búsqueda histórica",
  "empty": "Vacío",
  "home": "Página principal",
  "favorableRate": "Tasa de buenas críticas",
  "classification": "Categoría",
  "searchTips": "Búsqueda de fuente/producto/proveedor/pedido",
  "dailyNewArrival": "Nuevos productos diarios enumerados",
  "more": "Más",
  "recommend": "Recomendación",
  "recommendedProducts": "Productos Recomendados",
  "recommendedStore": "Tiendas recomendadas",
  "buyNow": "Comprar ahora",
  "addCart": "Añadir al carro de la compra",
  "complex": "Integrado",
  "price": "Precio",
  "retailPrice": "Precio al por menor",
  "originPrice": "Precio original",
  "service": "Servicio al Cliente",
  "collect": "Favoritos",
  "sold": "El volumen de ventas",
  "pageviews": "Cantidad de navegación",
  "quantity": "Cantidad",
  "freight": "Carga",
  "shipping": "Envío",
  "ship": "Bote",
  "buyTips": "Envío dentro de las 24 horas posteriores a la realización del pedido. Los siguientes pedidos están bajo control logístico y pueden enviarse con retraso. Preste atención a la información de logística o comuníquese con el servicio al cliente.",
  "totalPrice": "Precio total",
  "addCartMessage": "Agregado con éxito al carrito de compras",
  "addCartMessageFaild": "El producto ya existe en el carrito de compras.",
  "myAccount": "mi qcuenta",
  "buyHistory": "Registros de compra",
  "wishlist": "productos favoritos",
  "trackOrder": "Orden",
  "account": "Cuenta:",
  "sellerZone": "área comercial",
  "beSeller": "Conviértete en comerciante",
  "sellerPanelLogin": "Inicio de sesión de comerciante",
  "footTip": "© Copyright {name} Ltd 2024",
  "footTips": "{name} Limited está autorizado y regulado por la Autoridad de Conducta Financiera como corredor de crédito (713206) y trata exclusivamente con el prestamista Home Retail Group CardServices Limited como {name} Financial Services. {name} Financial Services está autorizado y regulado por la Autoridad de Conducta Financiera para proporcionar crédito (716148). Home Retail GroupCard Services Limited está registrada en el Reino Unido (04007072) en Avebury, 489-499 Avebury Boulevard, Milton Keynes, Reino Unido. MK9 2NW.",
  "item": "Artículo",
  "checkout": "Haz un pedido",
  "productDescription": "Descripción del Producto",
  "userEvaluation": "Opiniones de los usuarios",
  "AllProducts": "Todos los productos",
  "followers": "Seguir",
  "sales": "El volumen de ventas",
  "visitStore": "Visita la tienda",
  "authentic": "100% genuino",
  "dayReturns7": "7 días de regreso",
  "shippingDiscounts": "descuento de flete",
  "safePayment": "Pago seguro",
  "followed": "Seguido",
  "dashboard": "Tablero de instrumentos",
  "myOrder": "Mi pedido",
  "setUp": "Configuración",
  "successTips": "Exitoso",
  "copySuccess": "Replicación exitosa",
  "balance": "Saldo (USDT)",
  "sort": "Tipo",
  "commodity": "Producto",
  "browse": "El volumen de ventas",
  "recharge": "Recargar",
  "commodityCollection": "colección de productos",
  "withdraw": "Retiro de efectivo",
  "defaultAddress": "Dirección predeterminada",
  "addNewAddress": "agregar nueva dirección",
  "withdrawRecord": "registro de retiro de efectivo",
  "serialNumber": "N º de pedido.",
  "time": "Tiempo",
  "amount": "Cantidad",
  "processing": "En proceso",
  "fail": "Fallar",
  "blockchainNetwork": "Red de cadena de bloques",
  "records": "Registro",
  "withdrawAddress": "Dirección de retiro de efectivo",
  "withdrawInputTips": "Por favor ingrese la dirección de retiro",
  "copy": "Replicación",
  "enterTips": "Por favor escribe",
  "actualAccount": "cuenta real",
  "handlingFee": "Cargo por servicio",
  "confirm": "Confirmar recibo",
  "previous": "Paso anterior",
  "pleaseEnterAddress": "Por favor ingrese la dirección",
  "pleaseEnterQuantity": "Por favor ingrese la cantidad",
  "withdrawSuccess": "Pedidos enviados con éxito",
  "saveQr": "Guardar código QR",
  "pleaseEnterAmount": "Por favor ingrese el monto de la recarga",
  "expectedArrival": "Llegada prevista",
  "currentRate": "Tipo de cambio actual",
  "uploadTips": "Comprobante de pago (Subir captura de pantalla de los detalles del pago)",
  "clickUpload": "Haga clic para cargar",
  "uploadPhoto": "por favor sube fotos",
  "rechargeSuccessful": "recarga exitosa",
  "rechargeTips": "\"Mensaje de recarga: \"\"Por favor, complete el monto real de la transferencia con veracidad. De lo contrario, el sistema puede fallar en pasar la aprobación y afectar el progreso de la recarga.\"",
  "rechargeRecord": "Registro de recarga",
  "all": "Todo",
  "pending": "A pagar",
  "cancelled": "Cancelado",
  "delivered": "Para ser enviado",
  "confirmed": "Confirmado",
  "receipt": "Para ser recibido",
  "harvested": "Recibió",
  "comment": "Para ser revisado",
  "refund": "Reembolso/postventa",
  "cancelOrder": "Cancelar orden",
  "cancelReason": "Razón de la cancelación",
  "cancelOrderTitle": "Seleccione un motivo de cancelación del pedido",
  "returnOrderTitle": "Por favor selecciona el motivo de la devolución",
  "refundInstructions": "Instrucciones de reembolso",
  "returnDetailTips": "Por favor, dé una opinión sobre el producto.",
  "cancel": "Cancelar orden",
  "cancelOrder1": "Producto no recibido",
  "cancelOrder2": "No me gusta, no lo quiero",
  "cancelOrder3": "El vendedor envió los productos equivocados.",
  "cancelOrder4": "marca falsa",
  "cancelOrder5": "Menos envío, envío perdido",
  "cancelOrder6": "Producto recibido dañado",
  "cancelOrder7": "hay un problema de calidad",
  "cancelOrder8": "Negociar el reembolso con el comerciante",
  "cancelOrder9": "Otras razones",
  "cancelOrderSuccess": "Pedido cancelado con éxito",
  "returnOrderSuccess": "Enviar con éxito",
  "orderName": "Nombre",
  "orderEmail": "Correo electrónico",
  "orderAddress": "DIRECCIÓN",
  "orderNation": "País",
  "orderState": "Estado",
  "orderCity": "Ciudad",
  "orderPostCode": "Código Postal",
  "orderAmount": "Cantidad",
  "orderPrefix": "Orden total",
  "orderFee": "Impuestos",
  "orderSpecification": "Especificación",
  "orderCommodity": "Producto",
  "orderQuantity": "Cantidad",
  "orderUnitprice": "Precio unitario",
  "orderFreight": "Carga",
  "orderTax": "Impuesto",
  "orderTotal": "Total",
  "PaymentOrder": "Orden de pago",
  "Evaluate": "Revisar",
  "CancelOrder": "Cancelar orden",
  "RemindShip": "Recordatorio para el envío",
  "Refund": "Reembolso",
  "Submitareview": "Enviar reseñas",
  "Information": "Información",
  "wrongPassword": "Error de contraseña más de 3 veces. Inténtalo de nuevo mañana.",
  "Operate": "Operación",
  "Item": "Elementos)",
  "From": "De",
  "hint": "Consejos",
  "CheckDetails": "Ver detalles",
  "Payment": "Pago",
  "Cancel": "Cancelar",
  "refundSuccessfully": "Reembolso exitoso",
  "pendingPayment": "A pagar",
  "pay": "Pago",
  "LoginPassword": "Contraseña de inicio de sesión",
  "sure": "Por supuesto",
  "shippingAddress": "Dirección de recepción",
  "transactionPassword": "Clave de transacción",
  "markDefaultAddress": "Marcar como dirección de envío predeterminada",
  "edit": "Editado por",
  "delete": "Borrar",
  "Opt": "Seleccionar",
  "piece": "PC",
  "orderDetails": "Detalles del pedido",
  "shopCollection": "Añadir la tienda a favoritos",
  "addAddress": "agregar nueva dirección",
  "signUp": "Registro",
  "loginTips": "¿Ya tienes una cuenta?",
  "loginIn": "Acceso",
  "mobile": "Telefono no",
  '购物车还没有商品': "El carrito de compras no tiene productos",
  '去购物': "Ir de compras",
  "modifyAddress": "Modificar dirección",
  "desc": "Establecer como dirección predeterminada",
  "keep": "Mantener",
  "onlineService": "Servicios en línea",
  "send": "Enviar",
  "EsShop": "Tienda en línea",
  "desc3": "Ingrese la contraseña de la transacción",
  "desc4": "Ingrese su contraseña de transacción",
  "desc6": "Ingrese su contraseña de transacción nuevamente",
  "setUpPayPaw": "Establecer contraseña de transacción",
  "setSuccess": "Configuración exitosa",
  "confirmPayPaw": "Confirmar contraseña de transacción",
  "paymentSuccessful": "Pago exitoso",
  "desc5": "¿Dirección de envío incorrecta? Contacto",
  "customeService": "Atención al cliente en línea",
  "BackHome": "Volver a la página de inicio",
  "Checkorder": "Ver pedido",
  "ForgotPassword": "¿Olvidaste la contraseña?",
  "signIn": "Acceso",
  "noAccount": "¿Sin número de cuenta?",
  "pleaseEnterAccount": "Por favor ingrese número de cuenta",
  "pleaseEnterPassword": "Por favor, ingrese contraseña",
  "password": "Contraseña",
  "mobilePhone": "Número de teléfono",
  "pleaseEnterPhoneNumer": "Por favor, establezca el número de teléfono",
  "setPassword": "Configurar la clave",
  "noDataFound": "Datos no encontrados",
  "searchCountry": "Ingrese el nombre del país y el código de área para buscar",
  "pleaseEnterEmail": "Configure el buzón",
  "invitationCode": "Código de invitación",
  "plaeseEnterInvitaionCode": "Por favor, establezca el código de invitación",
  "pleaseSetLoginPassword": "Por favor, establezca la contraseña de inicio de sesión",
  "selectDeliveryAddress": "Seleccione la dirección de envío",
  "totalOf": "Total",
  "items": "Artículo",
  "orderSummary": "Resumen del pedido",
  "paymentMethod": "Método de pago",
  "Balance": "Balance",
  "payPal": "Paypal",
  "notOpen": "Este método de pago aún no está abierto en su región",
  "mastercard": "tarjeta MasterCard",
  "additional": "Extra",
  "handlingfee": "Cargo por servicio requerido",
  "goodsNumber": "Cantidad de productos",
  "deliveryFee": "Transporte",
  "totalNum": "Total",
  "new": "Nuevo",
  "oldPassword": "Contraseña anterior",
  "pleaseEnterOldPassword": "Por favor ingrese la contraseña anterior",
  "newPassword": "Nueva contraseña",
  "plaseeEnterNewPassword": "Por favor ingrese la nueva contraseña",
  "confirmPassword": "Confirmar Contraseña",
  "plaseeENterConfirmPassword": "Por favor ingrese la contraseña de confirmación",
  "twoPawword": "Dos contraseñas no son lo mismo",
  "rechargeAddress": "Dirección de recarga",
  "plaseEnterRechargeAddress": "Por favor, introduzca la dirección de recarga",
  "userCenter": "centro personal",
  "merchantSettled": "Entrada de comerciante",
  "upNew": "Nuevo producto listado",
  "balanceNot": "El saldo no es suficiente. Por favor, recarga.",
  "NoProductSelected": "Producto aún no seleccionado",
  "ShippingAddressNotSet": "Dirección de envío no establecida",
  "consigneeName": "Nombre del receptor",
  "email": "Correo electrónico:",
  "areaCode": "código de área internacional",
  "phoneNumber": "Número de teléfono",
  "nation": "País",
  "state": "Provincia/Estado/Estado",
  "city": "Ciudad",
  "postCode": "Código Postal",
  "address": "Dirección detallada",
  "addAddressOrModifyAddress": "Añadir nueva dirección/Modificar dirección",
  "setAsTheDefaultAddress": "Establecer como dirección predeterminada",
  "proceed": "Continuar",
  "btnSure": "Confirmar",
  "pleaseInput": "Por favor escribe",
  "allProduct": "Todos los productos",
  "myCommodityCollection": "productos favoritos",
  "myFollowedShops": "Sigue la tienda",
  "mySold": "Vendido",
  "myPageviews": "Cantidad de navegación",
  "myPraiseRate": "Tasa de buenas críticas",
  "myUnfollow": "Dejar de seguir",
  "inputNum": "Números",
  "inpuEmailErro": "Por favor, introduzca la dirección de correo electrónico correcta",
  "goodsShip": "Envío",
  "goodsShipTips": "Los productos serán enviados dentro de las 24 horas posteriores a la realización del pedido. Si existe control logístico para el siguiente pedido, el pedido puede retrasarse. Preste atención a la información de logística del pedido o comuníquese con el servicio al cliente.",
  "goodsFreight": "Transporte",
  "goodsFreeShipping": "Gratis",
  "goodsFreightTips1": "1. Composición del flete transfronterizo del producto: flete = tarifa de envío + flete de larga distancia + tarifa de entrega",
  "goodsFreightTips2": "2. Si no se cumplen las condiciones del franqueo, el flete se cobrará según las condiciones reales.",
  "goodsFreightTips3": "3. El derecho de interpretación final pertenece a la plataforma.",
  "pleaseValidPostCode": "Por favor ingrese más de 4 dígitos",
  "pleaseValidEmail": "Por favor, introduzca la dirección de correo electrónico correcta",
  "pleaseValidPhone": "Por favor ingrese el número de teléfono correcto",
  "productAvailable": "Este producto ha sido eliminado",
  "validatorMaxNumber": "La cantidad excede el límite",
  "validatorRequire": "Los elementos obligatorios no pueden ser nulos",
  "validatorPhone": "Por favor ingrese el número de teléfono correcto",
  "validatorEmail": "Ingrese el formato de correo electrónico correcto",
  "validatorPassword": "La contraseña se compone de 6-12 dígitos o letras(contiene caracteres especiales)",
  "validatorSixNumber": "Por favor ingrese 6 dígitos puros",
  "validatorFourMoreNumber": "Ingrese una combinación de 4-32 dígitos o letras",
  "validatorIpRule": "Formato de IP incorrecto",
  "validatorChineseAndEnglish": "Solo chino e inglés, ingrese el rango: 8-64 caracteres",
  "collectionSuccess": "Añadir a favoritos con éxito",
  "followedSuccess": "Seguir correctamente",
  "cancelSuccess": "Cancelado correctamente",
  "evaluateOrder": "Reseña con fotos",
  "evaluateOrderPlaceholder": "Por favor revise los productos",
  "operationSuccess": "Operación exitosa",
  "confirmReceiveGoods": "Confirmar la recepción del producto o no",
  "evaluateOrderSuccess": "Revisión exitosa",
  "yesterday": "Ayer",
  "notLogin": "Aún no has iniciado sesión.",
  "delAllHistoryRecord": "¿Está seguro de que desea eliminar todo el registro del historial?",
  "or": "O",
  "tipsRemindsText": "El comerciante recibirá un recordatorio después de que se le recuerde el envío.",
  "tipsRemindsCount": "Solo se puede recordar una vez.",
  "tipsRemindsMerchant": "recordar a los comerciantes",
  "tipsRemindsSuccess": "Recordatorio exitoso",
  "noCartTips": "Tu bolsa de compras está vacía. Empieza a comprar.",
  "defaultRate": "El sistema muestra por defecto revisiones favorables.",
  "prevPage": "Pagina anterior",
  "nextPage": "Siguiente página",
  "returnApply": "Petición para reembolso",
  "returnReason": "motivo del reembolso",
  "returnAmount": "Importe devuelto",
  "returnRemark": "Instrucciones de devolución",
  order: {
    confirm: "Confirmar recibo",
    cancel: "Cancelar orden",
    payment: "Pagar ahora",
    remind: "Recordatorio para el envío",
    return: "Solicitud de reembolso del producto",
    evaluate: "Revisar ahora",
    logistics: "ver logística",
    noRefund: "no reembolsado",
    refunding: "Reembolso en curso",
    refundSuccess: "Reembolso exitoso",
    refundFail: "Reembolso fallido",
        expressCompany: 'Empresa de mensajería',
        trackingNo: 'Número de seguimiento',
        noOrderShipping: 'Sin información de envío',
        noTransitSteps: 'Sin actualizaciones de seguimiento',
        logisticsLoadFail: 'Error al cargar la logística. Inténtelo de nuevo más tarde.'
  },
  "remindTitle": "Recordatorio para el envío",
  "remindContent": "Después de que se recuerda el envío, el comerciante recibirá el recordatorio. Solo se puede recordar una vez.",
  "remindSuccess": "Recordatorio exitoso",
  "remindRepeat": "Este pedido ha sido recordado.",
  "noComments": "No hay revisión en este momento",
  "storeSeach": "Buscar producto en esta tienda",
  "storeSeachTips1": "encontrado para ti",
  "storeSeachTips2": "Tiendas relacionadas encontradas",
  "storeSeachTips3": "Hogar",
  "creditTit": "Servicios de crédito",
  "getCoupons": "Obtén más cupones",
  "yourEmail": "Su dirección de correo electrónico",
  "subscription": "Suscripciones",
  "paymethods": "Método de pago",
  "footdec": "Los usuarios del sitio global de {name} provienen de {num} países de todo el mundo y utilizan {coin} para la liquidación. {coin} es una transacción sin fronteras que permite transacciones inmediatas y de bajo costo en todo el mundo sin esperas ni tarifas internacionales.",
  "custService": "Servicio al Cliente",
  "helpLine": "Atención al cliente en línea",
  "contactUs": "Contáctenos",
  "partner": "Proveedores cooperativos",
  "buyRules": "reglas del comprador",
  "sellerRules": "política del vendedor",
  "returnsAndEx": "Devoluciones y Cambio",
  "servicePolicy": "Política de servicio",
  "returnPolicy": "Política de devoluciones",
  "user_Center": "Centro de usuarios",
  "userReg": "Registro de usuario",
  "orderTrack": "consulta de pedido",
  "purchageHistory": "Historial de compras",
  "myPurse": "Mi billetera",
  "aboutUs": "Sobre nosotros",
  "Recruitment": "Espera a personas talentosas",
  "news": "Información de noticias",
  "stateMent": "Declaración de la esclavitud moderna",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "metamáscara",
  "homeBannertips1": "Conviértete en comerciante",
  "homeBannertips2": "comisión total",
  "homeBannertips3": "máx.",
  "homeBannerbtn": "Únete ahora",
  "homeDownloadtips1": "Centro comercial mayorista de comercio electrónico transfronterizo",
  "homeDownloadtips2": "oferta especial de la marca",
  "homeDownloadtips3": "descuento continuo",
  "homeDownloadtips4": "descarga de android",
  "homeDownloadtips5": "descarga de manzana",
  "homeDownloadtips6": "Escanee el código QR para descargar la aplicación",
  "homeIconTips1": "100% genuino",
  "homeIconTips2": "7 días de regreso",
  "homeIconTips3": "descuento de flete",
  "homeIconTips4": "pago seguro",
  "headerSearchTips": "Por favor ingrese la palabra clave para buscar",
  "collAccount": "modo de prestamo",
  "mine": "Mío.",
  "creditText1": "Los préstamos iniciales resuelven el problema de pedir dinero prestado",
  "creditText2": "Proporcionar servicios de préstamo de puesta en marcha y rotación de capital",
  "creditWorry": "Préstamo sin preocupaciones",
  "creditQuota": "Límite flexible",
  "creditQuotaINFO": "100.000 a 30.000.000 con límite flexible y sin restricciones, con un plazo máximo de préstamo de un año.",
  "quickLoan": "préstamo rápido",
  "creditReview": "Pase la auditoría en una hora como mínimo, si se pasa la revisión, el préstamo se liberará de inmediato.",
  "safe": "Seguro y sin preocupaciones",
  "safeInfo": "Sin hipoteca, sin depósito, sin devolución de llamada, porque esto es en realidad un asunto privado.",
  "about": "Sobre nosotros",
  "aboutText1": "\"Estamos comprometidos con los servicios financieros de préstamo, basados en la filosofía empresarial de \"\"cliente primero\"\", tenemos la misión de resolver el problema de la rotación de capital del cliente. Desde su creación, la empresa ha ayudado a numerosos clientes a resolver el problema de la rotación de capital.\"",
  "aboutText2": "Límite: 100,000-30,000,000, método de pago flexible con bajo interés, sin cargo por adelantado, préstamo en línea, sin llamadas telefónicas para verificación, información confidencial y préstamos en el mismo día.",
  "contactUs1": "Si no desea pedir dinero prestado a sus compañeros de nivel, contáctenos.",
  "committed": "Comprometidos con los servicios de préstamos para emprendedores",
  "financial": "Aborde sus preocupaciones financieras",
  "partnersTit": "Plataforma de préstamos en línea para socios",
  "application": "Solicitud de préstamo",
  "applicant": "Solicitante",
  "actualName": "Nombre real",
  "yourName": "Por favor ingrese el nombre",
  "term": "Plazo de préstamo",
  "applicationAmount": "Monto requerido",
  "rates": "Tasa de interés del préstamo",
  "loanMethod": "modo de prestamo",
  "accountB": "Saldo de la cuenta",
  "countryOf": "Nacionalidad",
  "myloan": "mi prestamo",
  "applyLoan": "Solicitar un préstamo",
  "loaned": "prestado",
  "interest": "Intereses acumulados",
  "esRepayment": "Reembolso estimado",
  "loanHistory": "registro de préstamo",
  "applicantDate": "Fecha de aplicacion",
  "repayment": "Reembolso",
  "cycle": "Ciclo de reembolso",
  "fixedRate": "Tasa de interés fija",
  "successLoan": "Préstamo exitoso",
  "Reapply": "Aplicar de nuevo",
  "borrow": "Préstamo fallido",
  "applicantIn": "Solicitud en curso",
  "repaid": "Reembolso",
  "overdue": "Atrasado",
  "estirepay": "Reembolso estimado",
  "loanDays": "Número de días prestados",
  "reAmount": "monto de reembolso",
  "repay": "Modo de pago",
  "entRepay": "Confirmar reembolso",
  "foryourmoney": "Si tiene escasez de fondos, no encuentra dónde pedir dinero prestado o le da vergüenza pedir dinero prestado a sus amigos, puede contactarnos. Contamos con todo el proceso de servicio profesional para responder tus dudas en cualquier momento. Nuestro objetivo es hacer que cada préstamo sea transparente, para que los clientes puedan usarlo de forma rápida y segura.",
  "onlineApplin": "Aplica online",
  "businessloan": "Solicitud de préstamo de puesta en marcha",
  "selectCountry": "Por favor seleccione una nacionalidad",
  "selectPeriod": "Por favor seleccione un período",
  "passPortImg": "Nº de DNI/Nº de Pasaporte",
  "uploadId": "Carga de foto de certificado/pasaporte",
  "readAndAgree": "He leído y estoy de acuerdo",
  "loanAgree": "Acuerdo de prestamo",
  "submitApplica": "Presentación de solicitud",
  "photoExample": "Ejemplo de toma de fotografías.",
  "discounted": "productos con descuento",
  "days": "día",
  "privacyPolicy": "Política de privacidad",
  "delivery": "Entrega y recogida",
  "checkAgreement": "¡Marque el acuerdo!",
  "businessPhone": "Teléfono de negocios",
  "businessEmail": "Correo electrónico corporativo",

  "提交失败": "Enviar fallido",
  "充值金额不能小于1": "El importe de la recarga no puede ser inferior a 1 (incluidos dos decimales)",
  "请切换其他语言后查看": "Cambie a otro idioma para ver",
  "我的购物车": "Mi carrito de compras",
  "推荐商品": "Productos Recomendados",
  "猜你喜欢": "Supongo que te gusta.",
  "暂无店铺": "No se encontró ninguna tienda",
  "添加失败": "Error al enviar. Por favor, inténtelo de nuevo más tarde",
  "提交订单": "Envío de pedidos",
  recommendclass: "Categoría recomendada",
  "滑动验证": "Validación deslizante",
  "最多上传9张图片": "Máximo 9 fotos",
  "账号注销": "Cierre de sesión",
  "App下载(买家端)": "Descarga de App (comprador)",
  "App下载(卖家端)": "Descarga de App (vendedor)",
  "确定注销": "Confirmar cierre de sesión",
  "您的账号": "Su cuenta",
  "为什么要离开": "¿Por qué dejar",
  "您还有余额,不能注销账号": "Todavía tienes saldo, no puedes cerrar sesión!",
  "请输入注销理由": "Ingrese el motivo de cierre de sesión",
  "您确认要注销吗?": "¿Estás seguro de que quieres cerrar sesión?",
  "我再考虑下": "Lo pensaré de nuevo",
  "同意注销": "De acuerdo en cerrar sesión",
  "注销成功": "Cierre de sesión exitoso",
  "请选择": "Por favor seleccione",
  "绑定成功": "Vinculación exitosa",
  "提款地址绑定": "Vinculación de dirección de retiro",
  "加值": "Recarga",
  "提领": "Retiro",
  "平台人工发起退款": "Reembolso iniciado por el personal de la plataforma",
  "银行卡": "Tarjeta bancaria",
  "联系商家": "Contactar al vendedor",
  footTipTikTok:'BizSpring ©️2024 Derechos de autor',
  "备注": "Observaciones",
  "最多包含10位小数": "Máximo 10 decimales",
  "长时间未付款，系统自动取消订单": "Si no paga durante mucho tiempo, el sistema cancelará el pedido automáticamente",
  "企业电话": "Teléfono de negocios",
  "当前余额": "Saldo actual",
  "职业机会": "Oportunidad de carrera",
  "加密货币": "Moneda cifrada",
  "银行卡": "Tarjeta bancaria",
  "充值币种": "Moneda de recarga",
  '参数缺失': "Falta de parámetros",
  '充值数量必填': "La cantidad de recarga es obligatoria",
  "充值金额": "Importe de recarga",
  "充值金额不得小于": "El importe de la recarga no puede ser inferior a",
  "充值金额不得大于": "El importe de la recarga no puede ser superior a",
  "请先选择币种": "Por favor seleccione la moneda primero",
  "开户行": "Banco",
  "请输入开户行名称": "Ingrese el nombre del banco",
  "银行卡号": "Número de tarjeta bancaria",
  "请输入银行卡号": "Ingrese el número de tarjeta bancaria",
  "点击去支付": "Haga clic para pagar",
  "企业证明": "Certificado de empresa",
  "客户端下载": "Descargar cliente",
  "提现方式": "Forma de retiro",
  "仅能绑定一个收款地址!": "¡Solo se puede vincular una dirección de recepción!",
  "cancelInfo":"¡advertir! Tenga cuidado de cancelar la cuenta. Si ya no usa la cuenta, puede hacer clic en [Aceptar la cancelación]. Es posible que no pueda registrarse dentro de unos días después de la cancelación.",
  TikTokFoot:"BizSpring es una plataforma social global de videos cortos BizSpring y la empresa comercial mayorista más grande de Asia, Alibaba, establecida en cooperación. Es una plataforma global de comercio electrónico y tiene tres almacenes inteligentes autónomos en el mundo, ubicados en Toronto, Canadá, Los Ángeles y Chiba, Japón. Los productos a la venta en la aplicación incluyen productos populares de Japón, Corea del Sur, China y otros países asiáticos. En la actualidad, el número total ha superado los 50.000 y continúa creciendo rápidamente."
,
  "getCouponSuccess": "Cupón recibido",
  "liveRooms": "Salas en Vivo",
  "liveStreaming": "En Vivo",
  "notStarted": "No Iniciado",
  "finished": "Finalizado",
  "myPoints": "Mis Puntos",
  "searchGoods": "Buscar Productos",
  "points": "Puntos",
  "point": "Puntos",
  "stock": "Stock",
  "spec": "Especificación",
  "exchangeNow": "Canjear Ahora",
  "currentPoint": "Mis Puntos",
  "pointNotEnough": "Puntos insuficientes"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "西班牙语(es)",
    "addImageHint": "(Añada imágenes)",
    "deleteNode": "Eliminar",
    "topPos": "Arriba {n}",
    "col": "Columna {n}",
    "pos": "Posición {n}",
    "decoType_container": "Contenedor",
    "decoType_title": "Texto de título",
    "decoType_richText": "Texto enriquecido",
    "decoType_notice": "Aviso",
    "decoType_blank": "Espaciador",
    "decoType_banner": "Carrusel",
    "decoType_imageSingle": "Imagen única",
    "decoType_imageMulti": "Varias imágenes",
    "decoType_video": "Vídeo",
    "decoType_goodsRecommend": "Productos recomendados",
    "decoType_goodsSelection": "Selección de productos",
    "decoType_seckill": "Venta flash",
    "decoType_groupBuy": "Compra en grupo",
    "decoType_coupon": "Cupón",
    "decoType_searchNav": "Navegación de búsqueda",
    "decoType_search": "Cuadro de búsqueda",
    "decoType_searchBox": "Cuadro de búsqueda",
    "decoType_categoryNav": "Navegación por categorías",
    "decoType_goodsCategory": "Categoría de productos",
    "decoType_navIconRow": "Iconos de navegación",
    "decoType_imageScroll": "Desplazamiento de imágenes",
    "decoType_pageBanner": "Banner de página",
    "decoType_tabs": "Pestañas",
    "decoType_brand": "Marca",
    "decoType_storeRecommend": "Tiendas recomendadas",
    "decoType_hotSelection": "Selección popular",
    "decoType_footerLinkGroup": "Enlaces de pie de página",
    "decoType_partnerLogoRow": "Socios",
    "decoType_icpInfo": "Info ICP",
    "decoType_topNavMenu": "Navegación superior",
    "decoType_logoBlock": "Logotipo",
    "decoType_langSwitcher": "Idioma",
    "decoType_currencySwitcher": "Moneda",
    "decoType_loginBlock": "Iniciar sesión",
    "decoType_cartIcon": "Carrito",
    "decoType_messageIcon": "Mensajes",
    "seckillPrice": "Precio flash",
    "seckillTag": "Venta flash",
    "seckillCountdown": "Termina en",
    "seckillNotStarted": "Próximamente",
    "seckillRushing": "En curso",
    "seckillWillStart": "Próximamente",
    "seckillBuy": "Comprar (flash)",
    "groupPrice": "Precio en grupo",
    "groupRequiredNum": "personas para el grupo",
    "noGroupBuy": "Comprar solo",
    "groupRule1": "1. Elegir producto",
    "groupRule2": "2. Iniciar grupo",
    "groupRule3": "3. Grupo completo → envío",
    "marketingMoneyOff": "Descuento",
    "marketingFreeShipping": "Envío gratis",
    "marketingGift": "Regalo",
    "marketingCoupon": "Cupón",
    "marketingGroup": "Compra en grupo",
    "marketingSeckill": "Venta flash",
    "marketingExpired": "Promoción caducada",
    "marketingNotActive": "Promoción inactiva",
    "alreadyGotCoupon": "Obtenido",
    "couponReceived": "Recibido",
    "hotSearch": "Búsqueda popular:"
}